import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { DepositContext } from "@state/context/payment/DepositContext";
import { observer } from "mobx-react";

export default observer(function DepositLimitInfoMessage() {
	const depositStore = useContext(DepositContext);
	const rootStore = useRootAppStore();
	const { t } = useTranslation("my-limits");

	const isLugas =
		depositStore.depositLimitStore.limitData?.userLimits?.[0]?.isLugas;
	const availableBudget =
		depositStore.depositLimitStore.limitData?.availableBudget;

	if (isLugas) {
		if (availableBudget == null) {
			return (
				<div className="message__content">
					{t("DEPOSIT_LUGAS_LIMIT_REACHED_NO_PARTIAL")}
				</div>
			);
		}

		return (
			<div className="message__content">
				{t("DEPOSIT_LUGAS_LIMIT_REACHED", {
					0: depositStore.depositLimitStore.limitData
						?.availableBudget,
					1: rootStore.userAuthStore.currency,
				})}
			</div>
		);
	}

	if (availableBudget == null) {
		return (
			<div className="message__content">
				{t("DEPOSIT_LIMIT_REACHED_NO_PARTIAL", {
					0: depositStore.depositLimitStore.getLimitName(),
					1: depositStore.depositLimitStore.limitData?.userLimits?.[0]
						.amount,
					2: rootStore.userAuthStore.currency,
				})}
			</div>
		);
	}

	return (
		<div className="message__content">
			{t("DEPOSIT_LIMIT_REACHED", {
				0: depositStore.depositLimitStore.getLimitName(),
				1: depositStore.depositLimitStore.limitData?.userLimits?.[0]
					.amount,
				2: rootStore.userAuthStore.currency,
				3: depositStore.depositLimitStore.limitData?.availableBudget,
				4: rootStore.userAuthStore.currency,
			})}
		</div>
	);
});
